import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import api from "../../util/api";

const initialState = {
  loading: false,
};

const asyncLogin = createAsyncThunk(
  "admin/login",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post("/api/login", payload);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // log in
    builder.addCase(asyncLogin.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(asyncLogin.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(asyncLogin.rejected, (state) => {
      state.loading = false;
    });
  },
});

export { asyncLogin };

export default authSlice.reducer;
